var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle4, _circle5, _circle6, _path9, _path10, _path11, _path12, _ellipse, _path13, _path14, _path15, _path16, _ellipse2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _rect, _rect2, _circle7, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHostWaitingEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 323,
    viewBox: "0 0 500 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 168.11,
    cy: 176.991,
    r: 44.755,
    fill: "#D9DFE6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.773,
    cy: 20.912,
    r: 8.341,
    fill: "#D9DFE6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.182,
    cy: 124.858,
    r: 19.57,
    fill: "#D9DFE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.182 301.951a4.811 4.811 0 0 1 4.812-4.812h87.263a4.812 4.812 0 1 1 0 9.624h-87.263a4.811 4.811 0 0 1-4.812-4.812zM126.885 302.272a4.812 4.812 0 0 1 4.812-4.812h6.256a4.812 4.812 0 0 1 0 9.625h-6.256a4.812 4.812 0 0 1-4.812-4.813z",
    fill: "#ECF0F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m249.055 135.284 31.809 29.63c6.093 5.676 6.432 15.218.756 21.311-5.677 6.094-15.218 6.432-21.311.756l-31.809-29.63 20.555-22.067zM214.476 69.01l8.652-21.916a3.208 3.208 0 0 1 2.634-2.011l13.09-1.434a3.208 3.208 0 0 1 2.923 1.273l7.029 9.444c.271.364.462.782.56 1.225l3.519 15.987a3.209 3.209 0 0 1-2.215 3.763l-13.247 3.957a3.212 3.212 0 0 1-1.645.05l-13.608-3.161a3.227 3.227 0 0 1-.774-.29l-5.434-2.873a3.208 3.208 0 0 1-1.484-4.014z",
    fill: "#0A76F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m242.615 116.837 7.186 4.493c8.322 5.204 19.323 1.782 23.225-7.223l14.922-34.445a3.208 3.208 0 0 0-.865-3.719l-20.212-17.195a3.21 3.21 0 0 0-5.001 1.11c-3.279 7.176-10.451 22.822-15.623 33.767-7.481 15.833-3.632 23.212-3.632 23.212z",
    fill: "#EAF3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.898 110.1c0-16.346 13.251-29.596 29.596-29.596h3.85c16.345 0 29.596 13.25 29.596 29.596 0 16.345-13.251 29.595-29.596 29.595h-3.85c-16.345 0-29.596-13.25-29.596-29.595z",
    fill: "#EAF3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.898 154.854c0-8.328 6.751-15.079 15.079-15.079h43.953v.642c0 16.301-13.215 29.516-29.516 29.516h-14.437c-8.328 0-15.079-6.751-15.079-15.079z",
    fill: "#2D8CFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m227.018 153.41 2.53 50.145c.419 8.317-5.983 15.4-14.3 15.819M198.021 128.146a3.209 3.209 0 0 1 3.209-3.208h54.7v16.121l-57.909 9.063v-21.976z",
    fill: "#2D8CFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M216.637 101.773c.299-5.346 4.602-9.72 9.956-9.72h22.92a6.416 6.416 0 0 1 6.416 6.417v26.497l-49.727.292s8.536-9.241 9.705-16.166c.361-2.14.588-4.771.73-7.32z",
    fill: "#2D8CFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.602 138.572c0-.708.574-1.283 1.283-1.283h31.761a1.283 1.283 0 0 1 0 2.567h-31.761a1.283 1.283 0 0 1-1.283-1.284zM237.322 123.013a1.284 1.284 0 0 1-1.283-1.284V93.337a1.284 1.284 0 0 1 2.567 0v28.392c0 .709-.575 1.284-1.284 1.284z",
    fill: "#0A76F9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.653,
    cy: 97.347,
    r: 1.283,
    fill: "#0A76F9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.653,
    cy: 107.613,
    r: 1.283,
    fill: "#0A76F9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.653,
    cy: 117.88,
    r: 1.283,
    fill: "#0A76F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m227.056 80.985 1.684-7.058 2.326.561 8.742 1.203 1.604 5.855-5.454 2.888-8.902-3.45z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M229.028 86.866a5.605 5.605 0 0 0 7.324-3.035l-10.36-4.29a5.607 5.607 0 0 0 3.036 7.325z",
    fill: "#0A76F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M241.113 85.418a3.637 3.637 0 0 0 1.521-4.914l-6.435 3.393a3.637 3.637 0 0 0 4.914 1.52z",
    fill: "#0A76F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M213.603 82.371a.642.642 0 0 1 .433-.798l4.614-1.368c.339-.101.696.093.797.432l4.699 15.84-5.844 1.734-4.699-15.84zM246.835 85.145a.642.642 0 0 1 .746-.517l4.735.855a.642.642 0 0 1 .518.745l-1.717 9.51-5.999-1.084 1.717-9.509z",
    fill: "#2D8CFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.317,
    cy: 61.094,
    rx: 14.517,
    ry: 17.485,
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.04 64.474a.641.641 0 0 1 .88.22l.189.314a2.47 2.47 0 0 1-1.013 3.478.642.642 0 1 1-.574-1.148 1.186 1.186 0 0 0 .486-1.67l-.188-.313a.642.642 0 0 1 .22-.88z",
    fill: "#C3DDFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M234.545 58.62c-.632 0-.883-.817-.36-1.172l1.169-.793a.641.641 0 0 1 .918.215l.45.793a.641.641 0 0 1-.558.958h-1.619zM243.873 57.474c.525.352.279 1.171-.353 1.175l-1.412.01a.641.641 0 0 1-.644-.69l.067-.909a.641.641 0 0 1 .996-.486l1.346.9z",
    fill: "#C4DDFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m237.959 44.837.166.377c.721 2.085 1.27 3.017.721 4.33-3.335 7.985-10.342 10.45-12.592 10.588h-.676a3.214 3.214 0 0 1-2.364-1.039 3.212 3.212 0 0 0-4.015-.583l-1.767 1.06 5.05-12.73a3.205 3.205 0 0 1 2.36-1.965l9.559-1.89a3.21 3.21 0 0 1 3.558 1.852z",
    fill: "#2D8CFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m239.496 53.042-1.799-7.835a3.186 3.186 0 0 0-.142-.458l-.222-.562a1.604 1.604 0 0 1 1.243-2.173l.992-.156a3.208 3.208 0 0 1 2.758.89l6.61 6.547c.48.475.797 1.09.907 1.756l1.509 9.123a.312.312 0 0 1-.41.35c-1.005-.35-3.302-1.208-4.717-2.157-2.242-1.503-4.425-4.684-5.465-6.335-.176-.28-.631-.153-.631.177v.761c0 .382-.548.444-.633.072zM223.099 73.618l-1.016-7.202-1.17-6.599c-.326-1.837-2.858-2.094-3.546-.36l-3.594 10.893a3.209 3.209 0 0 0 1.495 3.814l3.904 2.157a2.664 2.664 0 0 0 3.927-2.704z",
    fill: "#2D8CFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.526,
    cy: 62.791,
    rx: 3.369,
    ry: 6.096,
    transform: "rotate(-17.64 221.526 62.791)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.16 57.52a.641.641 0 0 1 .906-.042 10.718 10.718 0 0 1 2.043 2.587c.61 1.065 1.021 2.163 1.224 3.194a.642.642 0 0 1-1.259.248c-.174-.883-.532-1.85-1.078-2.804a9.458 9.458 0 0 0-1.794-2.277.641.641 0 0 1-.042-.906zM238.092 78.22a.641.641 0 0 1-.536.731 10.73 10.73 0 0 1-3.297-.034c-1.211-.194-2.323-.564-3.253-1.054a.64.64 0 1 1 .597-1.135c.797.419 1.774.748 2.859.921a9.446 9.446 0 0 0 2.899.034.64.64 0 0 1 .731.537z",
    fill: "#E4EFFB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m245.388 72.873 1.725-17.11a1.539 1.539 0 0 1 3.011-.264l4.171 14.76c.226.796.134 1.649-.255 2.38l-.696 1.307c-.36.675-.949 1.2-1.662 1.48l-1.932.756c-2.234.875-4.603-.922-4.362-3.309z",
    fill: "#2D8CFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M248.07 59.17c-.385.064-1.818-.669-2.487-1.043l.882 4.01-1.764 7.7c-.134 1.577-.241 4.62.401 4.17.642-.449 1.658-3.341 2.085-4.732l.883-4.892V59.17z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m197.941 253.827 2.047-45.178c.372-8.197 7.381-14.504 15.572-14.012",
    fill: "#2D8CFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m202.759 261.171-.346-7.076 3.001-.527 11.427-3.305.178 9.109-4.755 4.454-9.505-2.655z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M195.048 249.113a.642.642 0 0 1 .671-.611l32.688 1.533a.642.642 0 0 1 .611.671l-.316 6.73a.642.642 0 0 1-.671.611l-32.688-1.534a.642.642 0 0 1-.611-.671l.316-6.729zM195.161 290.628c.128-8.858 7.414-15.935 16.272-15.806l6.001.087c8.859.129 15.935 7.414 15.807 16.272l-.044 3.025a1.284 1.284 0 0 1-1.302 1.264l-36.797-.534.063-4.308z",
    fill: "#0A76F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A76F9",
    d: "m198.894 264.441 25.013.363-.251 17.313-25.013-.363z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M195.683 261.756a3.149 3.149 0 0 1 3.194-3.103l24.685.359a3.149 3.149 0 1 1-.092 6.296l-24.685-.358a3.148 3.148 0 0 1-3.102-3.194zM195.04 295.191a.372.372 0 0 1 .378-.366l37.189.54c.206.003.37.172.367.377a1.86 1.86 0 0 1-1.888 1.834l-34.212-.497a1.862 1.862 0 0 1-1.834-1.888z",
    fill: "#0165DE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.449 274.384a1.605 1.605 0 0 1-1.613-1.596l-.026-4.731a1.605 1.605 0 0 1 3.209-.018l.025 4.732a1.604 1.604 0 0 1-1.595 1.613z",
    fill: "#0165DE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m264.109 217.525-6.897-33.221c-1.699-8.183 3.644-16.169 11.856-17.721",
    fill: "#0A76F9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m271.759 224.871-1.054-6.437 4.616.577 9.361.119.209 7.382-5.77 2.188-7.362-3.829z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M262.056 213.825a.642.642 0 0 1 .651-.632l32.72.481a.64.64 0 0 1 .632.651l-.099 6.736a.64.64 0 0 1-.651.632l-32.72-.48a.643.643 0 0 1-.632-.651l.099-6.737z",
    fill: "#0165DE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M273.089 240.813a1.285 1.285 0 0 1 1.311-1.255l18.911.415c8.857.194 15.88 7.532 15.686 16.389l-.045 2.038a1.282 1.282 0 0 1-1.311 1.255l-34.948-.766.396-18.076z",
    fill: "#0A76F9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m266.369 239.383 16.517.362-.424 19.359-14.913-.327a1.605 1.605 0 0 1-1.569-1.639l.389-17.755z",
    fill: "#0A76F9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m266.579 229.792 26.108.572-.21 9.591-26.108-.572.21-9.591z",
    fill: "#0A76F9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M264.013 227.224a2.998 2.998 0 0 1 3.062-2.93l25.324.555a2.996 2.996 0 1 1-.131 5.991l-25.325-.555a2.997 2.997 0 0 1-2.93-3.061zM266.339 258.841a.354.354 0 0 1 .362-.346l41.682.914c.195.004.35.166.346.361a1.77 1.77 0 0 1-1.809 1.732l-38.85-.852a1.77 1.77 0 0 1-1.731-1.809z",
    fill: "#0165DE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.594 239.435a1.605 1.605 0 0 1-1.601-1.607l.009-4.348a1.604 1.604 0 1 1 3.208.007l-.008 4.347a1.605 1.605 0 0 1-1.608 1.601z",
    fill: "#0165DE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.301 178.368a2.848 2.848 0 0 1 3.692.354l1.186 1.234a2.847 2.847 0 0 1-1.175 4.682c.087.207.151.427.187.659l.642 4.031a2.847 2.847 0 0 1-5.599 1.023l.449 2.819a2.846 2.846 0 1 1-5.622.896l-.355-2.228a2.847 2.847 0 0 1-5.64.763l-.335-2.102a3.02 3.02 0 0 1-5.842-.499l-.214-1.348a3.007 3.007 0 0 1 .36-1.974c.053-6.068 4.988-10.97 11.068-10.97 2.749 0 5.263 1.002 7.198 2.66z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m205.157 89.526 2.501 28.291-8.001 58.206a3.21 3.21 0 0 1-2.644 2.727l-25.607 4.324c-1.945.328-3.713-1.154-3.685-3.126.118-8.227.825-28.072 4.791-40.009 11.826-35.591 32.645-50.413 32.645-50.413z",
    fill: "#EAF3FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 233.793,
    y: 61.014,
    width: 3.689,
    height: 1.283,
    rx: 0.642,
    fill: "#C3DDFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 240.852,
    y: 61.014,
    width: 3.689,
    height: 1.283,
    rx: 0.642,
    fill: "#C3DDFF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.793,
    cy: 69.997,
    r: 1.283,
    fill: "#C3DDFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M257.695 58.607h22.779v9.785h-22.779v-9.785zM280.794 57.806c0-.709.574-1.283 1.283-1.283h26.147c.709 0 1.283.574 1.283 1.283v11.55c0 .708-.574 1.283-1.283 1.283h-26.147a1.283 1.283 0 0 1-1.283-1.284v-11.55z",
    fill: "#2D8CFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M307.903 57.164c0-.709.575-1.283 1.284-1.283h26.147c.708 0 1.283.574 1.283 1.283v12.993c0 .71-.575 1.284-1.283 1.284h-26.147a1.284 1.284 0 0 1-1.284-1.284V57.164z",
    fill: "#2D8CFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M334.531 56.041c0-.709.575-1.283 1.284-1.283h2.727c.708 0 1.283.574 1.283 1.283v15.56c0 .709-.575 1.283-1.283 1.283h-2.727a1.284 1.284 0 0 1-1.284-1.283V56.04zM256.091 58.929a1.283 1.283 0 1 1 2.566 0v9.143a1.283 1.283 0 1 1-2.566 0V58.93z",
    fill: "#0A76F9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M280.397 57.084a1.203 1.203 0 0 1 2.407 0v13.154a1.203 1.203 0 0 1-2.407 0V57.084zM307.668 56.442a1.203 1.203 0 0 1 2.406 0V71.2a1.203 1.203 0 0 1-2.406 0V56.442z",
    fill: "#0165DE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.363 57.955a2.247 2.247 0 0 0 4.433.736l.373-2.248a2.246 2.246 0 1 0-4.433-.736l-.373 2.248zm4.308 1.503a2.248 2.248 0 0 0 4.433.735l.107-.642a2.247 2.247 0 0 0 4.445.618 2.246 2.246 0 0 0 4.445.653l.373-2.248a2.246 2.246 0 0 0-4.423-.793 2.246 2.246 0 0 0-4.445-.653l-.106.642a2.248 2.248 0 0 0-4.456-.56l-.373 2.248z",
    fill: "#EAF3FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M262.405 70.67a2.247 2.247 0 0 1 .741-3.09l1.942-1.192a2.247 2.247 0 0 1 2.35 3.83l-1.943 1.192a2.247 2.247 0 0 1-3.09-.74zM264.059 61.49a2.247 2.247 0 0 1-1.848-2.584l.373-2.248a2.247 2.247 0 1 1 4.433.736l-.373 2.248a2.247 2.247 0 0 1-2.585 1.848z",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M268.367 62.993a2.247 2.247 0 0 1-1.849-2.585l.374-2.248a2.248 2.248 0 0 1 4.433.736l-.374 2.248a2.246 2.246 0 0 1-2.584 1.849z",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M272.928 62.911a2.247 2.247 0 0 1-1.848-2.584l.373-2.248a2.247 2.247 0 1 1 4.433.736l-.373 2.247a2.247 2.247 0 0 1-2.585 1.849z",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M277.364 63.62a2.247 2.247 0 0 1-1.849-2.584l.374-2.248a2.247 2.247 0 0 1 4.433.736l-.374 2.248a2.246 2.246 0 0 1-2.584 1.849z",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.65 264.415a3.208 3.208 0 0 1 3.208-3.208h39.141a3.208 3.208 0 0 1 3.208 3.208v4.306l13.214 7.913a3.208 3.208 0 0 1 1.104 4.4l-1.906 3.183 5.651-.148a3.208 3.208 0 0 1 3.291 3.123l.26 9.947h28.915a4.812 4.812 0 0 1 0 9.625H259.865a4.812 4.812 0 0 1 0-9.625h5.972l-7.32-12.674a3.208 3.208 0 0 1 1.174-4.383l9.959-5.752v-9.915z",
    fill: "#ECF0F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostWaitingEmpty);
export default __webpack_public_path__ + "static/media/host_waiting_empty.d8053b1f2fb8449a124972a6bd8eff45.svg";
export { ForwardRef as ReactComponent };